/* MONTIVARIUS homepage collection with 3D (section mv-collection-3d).
   Colour chips pick the 3D colorway (card images link to the product page); the engine (mv-3d-summit.js / mv-3d-ridge.js)
   mounts itself into .mv3dv and loads three.js near the viewport. Everything is scoped to each section. */
(function(){
  // The section is used twice on the homepage, so this file can be included twice: run once
  if(window.__mvc3dInit) return;
  window.__mvc3dInit = true;

  function setup(sec){
    if(sec.__mvc3d) return; sec.__mvc3d = true;
    const viewer = sec.querySelector('.mvc3d-viewer');
    const root = sec.querySelector('.mvc3d-3d');
    const poster = sec.querySelector('.mvc3d-poster');
    if(!viewer || !root) return;

    // Fade from the product photo to 3D once the engine has drawn its first frame
    root.addEventListener('mv3d:ready', () => viewer.classList.add('is-ready'), {once:true});

    function select(slug){
      sec.querySelectorAll('.mvc3d-chip').forEach(c => c.setAttribute('aria-pressed', c.dataset.cw === slug ? 'true' : 'false'));
      sec.querySelectorAll('.mvc3d-card').forEach(c => c.classList.toggle('is-on', c.dataset.cw === slug));
      // Before 3D is up, show the matching product photo
      const img = sec.querySelector('.mvc3d-card[data-cw="' + slug + '"] img');
      if(img && poster && !viewer.classList.contains('is-ready')){
        poster.removeAttribute('srcset'); poster.removeAttribute('sizes'); poster.src = img.currentSrc || img.src;
      }
      root.dataset.colorway = slug;   // read by the engine if it has not started yet
      root.dispatchEvent(new CustomEvent('mv3d:colorway', {detail:slug}));
    }

    sec.addEventListener('click', e => {
      const b = e.target.closest('.mvc3d-chip');
      if(!b || !sec.contains(b)) return;
      select(b.dataset.cw);
    });
  }

  function setupAll(scope){ scope.querySelectorAll('.mvc3d').forEach(setup); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupAll(document));
  else setupAll(document);
  document.addEventListener('shopify:section:load', e => setupAll(e.target));
})();
